<template lang="pug">
  svg.svg-cooktop(:x="x" :y="y" :width="width" :height="height" viewBox="0 0 350 25" preserveAspectRatio="xMidYMid meet")
    title Cooktop
    path.cooktop-cls-1(d="M299.08,6.83H18.35v18.11H318.11ZM102.57,21H61.65v-8.17c0-1.67,1.71-3,3.81-3H98.77c2.1,0,3.8,1.35,3.8,3Zm183.66,0H245.31v-8.17c0-1.67,1.71-3,3.81-3h33.31c2.1,0,3.8,1.35,3.8,3Z")
</template>

<script>
export default {
  name: 'svg-cooktop',

  props: {
    x: Number,
    y: Number,
    width: {
      type: Number,
      default: 350,
    },
    height: {
      type: Number,
      default: 25,
    },
  },

};
</script>

<style lang="scss" scoped>
.svg-cooktop {

  .cooktop-cls-1 {
    fill: var(--fill-color-1, #666);
    stroke: var(--stroke-color-1, #000);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 10;
    vector-effect: non-scaling-stroke;
  }
}
</style>
